<template>
  <Modal
    :visible="isModal"
    pop_tit="취약점 인증서 다운로드"
    popSizeClass="popup__container--l"
    @close="closeModal"
  >
    <template #pop_content>
      <div class="board-wrapper">
        <div class="table-wrapper">
          <table class="list-table type-m-none-thead">
            <caption>
              다운로드 가능한 인증서 조회
            </caption>
            <colgroup>
              <col width="10%" />
              <col width="50%" />
              <col width="25%" />
              <col width="15%" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">
                  <label class="chk">
                    <input type="checkbox" class="chk" v-model="isAllChecked" />
                  </label>
                </th>
                <th scope="col">제목</th>
                <th scope="col">KVE</th>
                <th scope="col">상태</th>
              </tr>
            </thead>
          </table>
          <div class="table-body-scroll">
            <table class="list-table list-table--compact type-block--mobile">
              <caption>
                다운로드 가능한 인증서 조회
              </caption>
              <colgroup>
                <col width="10%" />
                <col width="50%" />
                <col width="25%" />
                <col width="15%" />
              </colgroup>
              <tbody>
                <tr v-for="item in kveList" :key="item.kve">
                  <td class="chk-field">
                    <label class="chk"
                      ><input
                        type="checkbox"
                        class="chk"
                        :value="item"
                        v-model="checkedItems"
                    /></label>
                  </td>
                  <td class="tit-field">
                    <div class="ellipsis">{{ item.vulTitle }}</div>
                  </td>
                  <td class="info-field">
                    {{ item.kve }}
                  </td>
                  <td class="info-field">{{ item.status }}</td>
                </tr>
              </tbody>
            </table>
            <div v-if="kveList == null || kveList.length == 0" class="no-data">
              {{
                isLoading
                  ? "데이터 조회중입니다. 잠시만 기다려주십시오."
                  : "검색 결과 없음..."
              }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #pop_buttons>
      <div class="pop-buttons-wrapper">
        <div class="pop-buttons-left">
          <span>발급 사유</span>
          <select
            name="issuedReason"
            id="issuedReason"
            v-model="issuedReason"
            class="issued-select"
          >
            <option
              v-for="item in issuedReasonList"
              :key="item.id"
              :value="item.cd"
            >
              {{ item.cdNm }}
            </option>
          </select>
          <input
            type="text"
            v-if="
              issuedReason === 'ISSUED_REASON_ETC' || issuedReason === 'WRITE'
            "
            v-model="issuedReasonDesc"
            class="form-table__input"
            placeholder="발급 사유를 작성해주세요."
          />
        </div>
        <button
          type="button"
          class="btn btn--m btn--blue .btn__wrap--center"
          @click="downloadPdf"
        >
          다운로드
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/component/Modal.vue";
import { computed, inject, onMounted, ref, toRaw } from "vue";
import { useStore } from "vuex";

export default {
  components: { Modal },
  props: {
    reportKveList: {
      type: Array,
      default: () => [],
    },
    isModal: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["close"],
  setup(props, { emit }) {
    const axios = inject("axios");
    const store = useStore();
    // data 정의
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");
    const checkedItems = ref([]);
    const kveList = ref([]);
    const saver = inject("filesaver");
    const issuedReason = ref("VERIFY");
    const issuedReasonDesc = ref("");
    const issuedReasonList = ref([]);

    // methods 정의
    const getKveList = () => {
      showLoading();
      axios
        .post("/report/pr/records/cert-list/get")
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            kveList.value = res.data.resList;
          } else {
            kveList.value = [];
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const getIssuedReasonCode = () => {
      axios
        .post("/report/pr/code/issued-reason/get")
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            const tmp = res.data.resList.filter((item) => item.cd !== "WRITE");
            issuedReasonList.value = tmp;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const downloadPdf = () => {
      if (!checkedItems.value.length) {
        alert("선택된 항목이 없습니다.");
        return;
      }

      const rawCheckedItems = toRaw(checkedItems.value);

      const data = {
        vulSummarys: rawCheckedItems,
        issuedReason: issuedReason.value,
        issuedReasonDesc: issuedReasonDesc.value,
      };

      showLoading();
      axios({
        method: "POST",
        url: "/report/pr/records/certificate/download",
        responseType: "blob",
        data: data,
      })
        .then((response) => {
          if (response.data.size === 0) {
            alert("해당 경로에 파일이 존재하지 않습니다.");
            return;
          }
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });
          const newFileName = `${rawCheckedItems[0].userId}_취약점_인증서.zip`;
          saver.saveAs(blob, newFileName);
          issuedReason.value = "VERIFY";
        })
        .catch((error) => console.log(error))
        .finally(() => hideLoading());
    };

    // computed 정의
    const isAllChecked = computed({
      get() {
        return (
          kveList.value.length > 0 &&
          checkedItems.value.length === kveList.value.length
        );
      },
      set(value) {
        if (value) {
          // 필터링된 목록만 전체 선택
          checkedItems.value = [...kveList.value];
        } else {
          checkedItems.value = [];
        }
      },
    });

    const closeModal = () => {
      checkedItems.value = [];
      emit("close");
    };

    // watch, computed 정의
    const isLoading = computed(() => store.state.loading.isLoading);

    // lifecycle 정의
    onMounted(() => {
      getKveList();
      getIssuedReasonCode();
    });
    // html에서 사용될 데이터 정의
    return {
      checkedItems,
      isAllChecked,
      getKveList,
      kveList,
      isLoading,
      issuedReason,
      issuedReasonDesc,
      issuedReasonList,
      downloadPdf,
      closeModal,
      getIssuedReasonCode,
    };
  },
};
</script>
